@if (actions?.length && (actions | allActionsIsHidden | async) === false) {
  <div class="row-action" (capClickOutside)="isOpen = false">
    <i (click)="isOpen = !isOpen" [class]="icon" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
       [attr.data-test]="'action_toggler_' + item?.id"></i>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayPositions]="positions"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
      (overlayOutsideClick)="isOpen = false">
      <ul class="row-action__items"
          [ngClass]="{'row-action__items--open': isOpen}">
          @for (action of actions; track action.key) {
            @if ((action?.hidden | observablePipe | async) !== true) {
              <li
                (click)="executeAction(action, item)"
                [attr.data-test]="action?.key || action?.value">
                <div class="row-action__icon">
                  <i [class]="action?.icon"></i>
                </div>

                <div class="row-action__info">
                  <p class="title">{{ action?.label | observablePipe | async }}</p>
                  @if ((action?.description | observablePipe | async); as description) {
                    <p class="description">
                      {{ description }}
                    </p>
                  }
                </div>
              </li>
            }
          }
      </ul>
    </ng-template>
  </div>
}
